import webcall from '@/libs/webcall';
import variables from '@/config/variables';
import urlParser from '@/utils/urlParser';
import accountBlobNormaliser from '@/utils/accountBlobNormaliser';

const ACCESS_TOKEN_KEY = 'access_token';

const methods = {
  retrieveUserInfomation() {
    let accessToken = null;

    // Retrieve accessToken from url
    const queries = urlParser.query.parse();
    if (queries.access_token) {
      accessToken = queries.access_token;
      localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
      delete queries.access_token;
      urlParser.query.set(queries);

    // Retrieve accessToken from localStorage
    } else if (localStorage.getItem(ACCESS_TOKEN_KEY)) {
      accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
    }

    return accessToken;
  },
  validateAccessToken(accessToken) {
    return webcall.user.validate(accessToken);
  },
  removeUserInformation() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
  },
};

const account = {
  namespaced: true,
  state: {
    isAuthenticated: null,
    accessToken: null,
    blob: null,
    // Verification
    shouldAskForVerification: null,
    shouldAskForAddingEmail: null,
    shouldAskForSignup: null,
    shouldAskForAgreement: null,
    needSignup: null,
  },
  getters: {

  },
  mutations: {
    updateUserInformation(state, userInformationBlob = {}) {
      const isAuthenticated = !!userInformationBlob.access_token;

      // Update state;
      state.accessToken = userInformationBlob.access_token || null;
      state.blob = (isAuthenticated)
        ? accountBlobNormaliser.cleanUpResponse(userInformationBlob)
        : {};
      // Sign up requirement's state
      state.shouldAskForVerification = !!state.blob.unverified_email;
      state.shouldAskForAddingEmail = !state.blob.primary_email && !state.shouldAskForVerification;
      state.shouldAskForSignup = !(state.blob.film_maker_details && state.blob.film_maker_details.name);
      state.shouldAskForAgreement = state.blob.film_license_agreement === 'not_signed' ||
                                    state.blob.film_license_agreement === 'not_latest';
      // Summary
      state.needSignup = state.shouldAskForVerification ||
                         state.shouldAskForAddingEmail ||
                         state.shouldAskForSignup ||
                         state.shouldAskForAgreement;
      state.isAuthenticated = isAuthenticated;
    },
  },
  actions: {
    initialiseAccount({ state, commit, rootState }) {
      const accessToken = methods.retrieveUserInfomation();
      if (!accessToken) {
        this.dispatch('account/logout', { clearOnly: true });
        return Promise.resolve();
      }

      return methods.validateAccessToken(accessToken)
        .then((data) => {
          commit('updateUserInformation', data.data);
          webcall.updateAccessToken(accessToken);
        })
        .catch((error) => {
          if (error.status === 401) {
            // Kick user only when request is unauthorized
            this.dispatch('account/logout', { clearOnly: true });
          }
          throw error;
        });
    },
    logout({ state, commit, rootState }, options = {}) {
      if (options.clearOnly) {
        commit('updateUserInformation');
        methods.removeUserInformation();
        return; // clear only. do not continue.
      }

      const logoutFrame = document.createElement('iframe');
      const logoutCallbackFnName = 'logoutCallbackFn';
      window[logoutCallbackFnName] = () => {
        commit('updateUserInformation');
        methods.removeUserInformation();
        document.body.removeChild(logoutFrame);
      };
      logoutFrame.setAttribute('style', 'display: none;');

      logoutFrame.src = `${variables.BASE_URL}/logout?origin=false&callback=${logoutCallbackFnName}`;
      document.body.appendChild(logoutFrame);
    },
  },
};

export default account;



// WEBPACK FOOTER //
// ./src/store/modules/account.js